import React, { Fragment, useState, useEffect } from "react"
import { Container } from "react-bootstrap"
import NavBarUser from "../../components/shared/NavBarUser"
import Title from "../../components/shared/Title"
import CardVotaciones from "../../components/user/CardVotaciones"
import {getVotacionesHistorial} from "../../services/user.service.js"

const MisVotaciones = () => {
  const [votaciones, setVotaciones] = useState()
	const [emptyVotaciones, setEmptyVotaciones] = useState()
	const [loader, setLoader] = useState()

	 useEffect(() => {
			const getData = async () => {
				setLoader(true)
				const res = await getVotacionesHistorial()
				console.log(res)
				if (res?.response === "success") {
					setVotaciones(res.data)
					setEmptyVotaciones(
						res.data.length===0
					)
				}
				setLoader(false)
			}
			getData()
		}, [])

  return (
		<Fragment>
			<NavBarUser />
			<Container className="mt-4">
				<Title
					title="Historial de Votaciones"
					descripcion="Aquí encontrará los procesos en los que ha participado"
				/>
				{emptyVotaciones ? (
					"No hay votaciones registradas"
				) : (
					<CardVotaciones votaciones={votaciones} loader={loader} isHistorial={true} />
				)}
			</Container>
		</Fragment>
	)
}

export default MisVotaciones
